module.exports = __webpack_public_path__ + "img/IMG_1039_FoamcoreMatted.a3bdb5f8.jpg";